'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/es-errors@1.3.0/~/es-errors/eval.js
// module id = 624
// module chunks = 0